enum FileType {
  CSV = 'text/csv',
  PDF = '.pdf',
  DOC = '.doc',
  DOCX = '.docx',
  PNG = 'image/png',
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  IMG = 'image/*',
  ZIP = 'application/x-zip-compressed',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}

export default FileType
